<template>
  <div class="fw error-404">
     <div class="box-wrapper">
        <div class="content-404">
            <h1 >404 Page not found</h1>
            <h2 class="fw">ขออภัย ไม่พบหน้าเว็บไซต์ที่ต้องการ</h2>
            <p>หน้าเว็บไซต์ดังกล่าวอาจมีการเปลี่ยนที่ เปลี่ยนชื่อ หรือพิมพ์ URL ไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง</p>
            <a href="/" class="btn btn-ctr-primary mt-2">กลับสู่หน้าหลัก</a>
        </div>
     </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.error-404{background-color: #fff;height:calc(80vh - 0px);display: flex;align-items: center;justify-content: center}
.box-wrapper{text-align: center;}
.content-404 { color:#666;}
.content-404 h1 { font-size: 2em;color:#666;}
.content-404 h2 { font-size: 3em;color:rgb(221 91 107)}
.content-404 p { margin-bottom: 10px;}
.content-404 a  { margin-top: 20px; display: inline-block;}
</style>